<template>
    <footer class="wrapper__footer">
        <p>
            <a
                class="wrapper__footer__link"
                :href="exits.lunchables"
                target="_blank"
                v-trackevent:val="'footer_visit-lunchables_exit'"
            >VISIT LUNCHABLES</a> |
            <a
                class="wrapper__footer__link"
                :href="exits.termsofservice"
                target="_blank"
                v-trackevent:val="'footer_terms-of-service_exit'"
            >TERMS OF SERVICE</a> |
            <a
                class="wrapper__footer__link"
                :href="exits.privacypolicy"
                target="_blank"
                v-trackevent:val="'footer_privacy-policy_overlay'"
            >PRIVACY POLICY</a>
            <br>
            For Questions,
            <a
                class="wrapper__footer__link underline"
                :href="exits.contact"
                target="_blank"
                v-trackevent:val="'footer_contact-us-here_exit'"
            >CONTACT US HERE</a>
        </p>

        <button
            class="wrapper__btn wrapper__footer__rules"
            @click="openRules"
            v-trackevent:val="'footer_official-rules_overlay'"
        ></button>
    </footer>
</template>

<script>
    import CONFIG from '@/config';

  export default {

    name: 'Footer',

    data() {

        return {
            exits: CONFIG.settings.exits
        };
    },

    methods: {

        openRules() {
            this.$emit('openOverlay', 'rules');
        }
    }
  }
</script>

<style scoped lang="scss">
    .wrapper__footer {
        background-color: #ed1d24;
        color: #FFFFFF;
        bottom: 0px;
        font-family: 'Open Sans', sans-serif;
        font-size: 12px;
        height: 51px;
        position: absolute;
        width: 100%;

        p {
            text-align: center;
            margin: 7px auto 0px auto;
            word-spacing: 1px;
            letter-spacing: 1px;
        }

        .underline {
            text-decoration: underline;
        }

        &__link {
            color: #FFFFFF;
            cursor: pointer;
            text-decoration: none;
            font-weight: bold;

            &:hover {
                color: #fce239;
                text-decoration: underline;
            }
        }

        &__rules {
            background-image: url('/images/footer_rules.png');
            height: 54px;
            position: absolute;
            right: 40px;
            top: -20px;
            width: 164px;

            &:hover {
                background-image: url('/images/footer_rules-hover.png');
            }
        }
    }
</style>
